// img

export const dummy = './img/dummy.avif';
export const dummy2 = './img/dummy2.avif';
export const dummy3 = './img/dummy3.avif';

export const logoNav = './img/logo-nav.avif';
export const home2n01 = './img/home2-01.avif';
export const home3china = './img/home3-china.avif';
export const home3hongkong = './img/home3-hongkong.avif';
export const home3indonesia = './img/home3-indonesia.avif';
export const home3japan = './img/home3-japan.avif';
export const home3southkorea = './img/home3-southkorea.avif';
export const home4bg = './img/home4-bg.avif';
export const home5logoInsurein = './img/home5-logo-insurein.avif';
export const home5img = './img/home5-img.avif';
export const home6bg = './img/home6-bg.avif';
export const about1img = './img/about1-img.avif';
export const about2img1 = './img/about2-img1.avif';
export const about2img2 = './img/about2-img2.avif';
export const about3img = './img/about3-img.avif';
export const about3imgMobile = './img/about3-img-mb.avif';
export const about4logoInsurein = './img/about4-logo-insurein.avif';
export const about4img1 = './img/about4-img1.avif';
export const about4img2 = './img/about4-img2.avif';
export const about4img3 = './img/about4-img3.avif';
export const about4img3Mobile = './img/about4-img3-mb.avif';
export const about4img4 = './img/about4-img4.avif';
export const about4img5 = './img/about4-img5.avif';
export const about4img6 = './img/about4-img6.avif';
export const about4img7 = './img/about4-img7.avif';
export const contactImg = './img/contact-img.avif';